module.exports = __webpack_public_path__ + "img/empresas.cb295bfe.svg";